import { EmailOptions } from './emailTypes'

export const SendEmail = (emailSubject: EmailOptions, userEmail?: string) => {
  const recipient = 'help@upapp.uk'
  const subject = encodeURIComponent(emailSubject)
  const body = encodeURIComponent(
    emailSubject === EmailOptions.REPORT_BUG
      ? `Hi Up team,\n\nI encountered an issue in the app. Here's what happened:\n[Please describe the bug, steps to reproduce it, and any other details]\n\nDevice & Browser:\n [e.g., iPhone 14 / Chrome on Windows]\n\n\n\nThanks for looking into this!\nUser: ${userEmail ?? ''}`
      : `Hi Up team,\n\nI'd like to get in touch about:\n[Write your message here]\n\nLooking forward to hearing from you!`,
  )

  window.location.href = `mailto:${recipient}?subject=${subject}&body=${body}`
}
